import script from "./MessageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageModal.vue?vue&type=script&setup=true&lang=ts"

import "./MessageModal.vue?vue&type=style&index=0&id=1c25de2d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c25de2d"]])

export default __exports__